import {
  TYCOON_AVATAR_IDS,
  defaultTycoonAvatarForSeat,
  normalizeTycoonAvatarId
} from './shared/tycoon-avatars.js';

export const TYCOON_STATE_VERSION = 3;
export const TYCOON_MONEY_SCALE = 10000;

const money = value => Math.round((Number(value) || 0) * TYCOON_MONEY_SCALE);
const formatVnd = amount => new Intl.NumberFormat('vi-VN').format(Math.round(Number(amount) || 0)) + ' ₫';
const moneyText = value => formatVnd(money(value));

export const TYCOON_START_CASH = money(1500);          // 15.000.000 ₫
export const TYCOON_PASS_START_BONUS = money(200);     // 2.000.000 ₫
export const TYCOON_JAIL_FEE = money(50);              // 500.000 ₫

export const TYCOON_GROUP_COLORS = Object.freeze({
  brown: '#8b5e3c',
  lightblue: '#67c7e8',
  pink: '#e36aa5',
  orange: '#f39a45',
  red: '#e45454',
  yellow: '#f2cf45',
  green: '#47a66d',
  darkblue: '#315fbd'
});

function property(name, group, price, rent, houseCost) {
  return {
    name,
    type: 'property',
    group,
    price: money(price),
    rent: rent.map(money),
    houseCost: money(houseCost)
  };
}

function railroad(name) {
  return { name, type: 'railroad', price: money(200) };
}

function utility(name, icon) {
  return { name, type: 'utility', price: money(150), icon };
}

export const TYCOON_TILES = Object.freeze([
  { name: 'BẮT ĐẦU', type: 'start', icon: '➜' },

  // Miền Nam / Tây Nam Bộ
  property('Cà Mau', 'brown', 60, [2, 10, 30, 90, 160, 250], 50),
  { name: 'KHÍ VẬN', type: 'community', icon: '★' },
  property('Bạc Liêu', 'brown', 60, [4, 20, 60, 180, 320, 450], 50),
  { name: 'Thuế thu nhập', type: 'tax', amount: money(200), icon: '₫' },
  railroad('Bến xe Miền Tây'),
  property('Cần Thơ', 'lightblue', 100, [6, 30, 90, 270, 400, 550], 50),
  { name: 'CƠ HỘI', type: 'chance', icon: '?' },
  property('An Giang', 'lightblue', 100, [6, 30, 90, 270, 400, 550], 50),
  property('Phú Quốc', 'lightblue', 120, [8, 40, 100, 300, 450, 600], 50),

  { name: 'THĂM TÙ', type: 'jail', icon: '🔒' },

  // Đông Nam Bộ
  property('Vũng Tàu', 'pink', 140, [10, 50, 150, 450, 625, 750], 100),
  utility('Điện lực', '💡'),
  property('TP. Hồ Chí Minh', 'pink', 140, [10, 50, 150, 450, 625, 750], 100),
  property('TP. Đồng Nai', 'pink', 160, [12, 60, 180, 500, 700, 900], 100),
  railroad('Ga Sài Gòn'),

  // Nam Trung Bộ / Tây Nguyên
  property('Phan Thiết', 'orange', 180, [14, 70, 200, 550, 750, 950], 100),
  { name: 'KHÍ VẬN', type: 'community', icon: '★' },
  property('Đà Lạt', 'orange', 180, [14, 70, 200, 550, 750, 950], 100),
  property('Nha Trang', 'orange', 200, [16, 80, 220, 600, 800, 1000], 100),

  { name: 'BÃI NGHỈ', type: 'free', icon: '🌴' },

  property('Buôn Ma Thuột', 'red', 220, [18, 90, 250, 700, 875, 1050], 150),
  { name: 'CƠ HỘI', type: 'chance', icon: '?' },
  property('Quy Nhơn', 'red', 220, [18, 90, 250, 700, 875, 1050], 150),
  property('Pleiku', 'red', 240, [20, 100, 300, 750, 925, 1100], 150),
  railroad('Ga Đà Nẵng'),

  // Miền Trung
  property('Hội An', 'yellow', 260, [22, 110, 330, 800, 975, 1150], 150),
  property('Đà Nẵng', 'yellow', 260, [22, 110, 330, 800, 975, 1150], 150),
  utility('Nước sạch', '🚰'),
  property('Huế', 'yellow', 280, [24, 120, 360, 850, 1025, 1200], 150),

  { name: 'ĐI TÙ', type: 'goto-jail', icon: '➡' },

  // Miền Bắc
  property('Vinh', 'green', 300, [26, 130, 390, 900, 1100, 1275], 200),
  property('Ninh Bình', 'green', 300, [26, 130, 390, 900, 1100, 1275], 200),
  { name: 'KHÍ VẬN', type: 'community', icon: '★' },
  property('Hạ Long', 'green', 320, [28, 150, 450, 1000, 1200, 1400], 200),
  railroad('Ga Hà Nội'),
  { name: 'CƠ HỘI', type: 'chance', icon: '?' },
  property('Hà Nội', 'darkblue', 350, [35, 175, 500, 1100, 1300, 1500], 200),
  { name: 'Thuế đặc biệt', type: 'tax', amount: money(100), icon: '◆' },
  property('Sa Pa', 'darkblue', 400, [50, 200, 600, 1400, 1700, 2000], 200)
]);

const CHANCE_CARDS = Object.freeze([
  { text: `Tiến đến BẮT ĐẦU. Nhận ${moneyText(200)} nếu đi qua.`, action: 'move', target: 0, collectStart: true },
  { text: 'Tiến đến Hà Nội.', action: 'move', target: 37, collectStart: true },
  { text: 'Tiến đến TP. Hồ Chí Minh.', action: 'move', target: 13, collectStart: true },
  { text: `Dự án đổi mới thành công. Nhận ${moneyText(150)}.`, action: 'money', amount: money(150) },
  { text: `Nhận hoàn phí dịch vụ ${moneyText(50)}.`, action: 'money', amount: money(50) },
  { text: `Nộp phạt hành chính ${moneyText(15)}.`, action: 'money', amount: -money(15) },
  { text: `Chi phí bảo trì khẩn cấp ${moneyText(100)}.`, action: 'money', amount: -money(100) },
  { text: 'Đi thẳng vào TÙ. Không nhận tiền khi qua BẮT ĐẦU.', action: 'jail' },
  { text: 'Nhận một thẻ Ra tù miễn phí.', action: 'jail-card' },
  { text: `Sửa chữa tài sản: ${moneyText(25)} mỗi nhà, ${moneyText(100)} mỗi khách sạn.`, action: 'repairs', house: money(25), hotel: money(100) }
]);

const COMMUNITY_CARDS = Object.freeze([
  { text: `Thưởng dự án cộng đồng. Nhận ${moneyText(200)}.`, action: 'money', amount: money(200) },
  { text: `Hoàn thuế. Nhận ${moneyText(100)}.`, action: 'money', amount: money(100) },
  { text: `Giải thưởng sáng tạo. Nhận ${moneyText(50)}.`, action: 'money', amount: money(50) },
  { text: `Phí y tế. Trả ${moneyText(50)}.`, action: 'money', amount: -money(50) },
  { text: `Bảo dưỡng thiết bị. Trả ${moneyText(100)}.`, action: 'money', amount: -money(100) },
  { text: 'Tiến đến BẮT ĐẦU.', action: 'move', target: 0, collectStart: true },
  { text: 'Đi thẳng vào TÙ.', action: 'jail' },
  { text: 'Nhận một thẻ Ra tù miễn phí.', action: 'jail-card' },
  { text: `Thu nhập tư vấn. Nhận ${moneyText(25)}.`, action: 'money', amount: money(25) },
  { text: `Sửa chữa tài sản: ${moneyText(40)} mỗi nhà, ${moneyText(115)} mỗi khách sạn.`, action: 'repairs', house: money(40), hotel: money(115) }
]);

function clampPlayerCount(value) {
  return Math.max(2, Math.min(4, Number(value) || 2));
}

function nextActiveIndex(players, fromIndex) {
  for (let offset = 1; offset <= players.length; offset++) {
    const idx = (fromIndex + offset) % players.length;
    if (!players[idx].bankrupt) return idx;
  }
  return fromIndex;
}

function asIndex(value) {
  const index = Number(value);
  return Number.isInteger(index) && index >= 0 && index < TYCOON_TILES.length ? index : null;
}

function isPurchasable(tile) {
  return tile && ['property', 'railroad', 'utility'].includes(tile.type);
}

function sanitizeAssetState(value = {}) {
  return {
    ownerId: typeof value.ownerId === 'string' ? value.ownerId : null,
    houses: Math.max(0, Math.min(5, Math.trunc(Number(value.houses) || 0))),
    mortgaged: Boolean(value.mortgaged)
  };
}

export class TycoonGame {
  constructor(playerCount = 2) {
    const count = clampPlayerCount(playerCount);
    this.version = TYCOON_STATE_VERSION;
    this.players = Array.from({ length: count }, (_, i) => ({
      id: `p${i + 1}`,
      name: `Người chơi ${i + 1}`,
      seatIndex: i,
      avatarId: defaultTycoonAvatarForSeat(i),
      cash: TYCOON_START_CASH,
      position: 0,
      properties: [],
      bankrupt: false,
      inJail: false,
      jailTurns: 0,
      jailCards: 0
    }));
    this.assets = {};
    TYCOON_TILES.forEach((tile, index) => {
      if (isPurchasable(tile)) this.assets[index] = { ownerId: null, houses: 0, mortgaged: false };
    });
    this.turnIndex = 0;
    this.phase = 'roll';
    this.lastRoll = null;
    this.pendingProperty = null;
    this.pendingDebt = null;
    this.pendingAfterDebt = null;
    this.winnerId = null;
    this.round = 1;
    this.extraRoll = false;
    this.consecutiveDoubles = 0;
    this.lastEvent = null;
    this.log = ['Ván Cờ tỷ phú Việt Nam bắt đầu.'];
  }

  get currentPlayer() {
    return this.players[this.turnIndex];
  }

  get finished() {
    return Boolean(this.winnerId);
  }

  propertyState(index) {
    const idx = asIndex(index);
    return idx === null ? null : this.assets[idx] || null;
  }

  ownerOf(index) {
    const asset = this.propertyState(index);
    if (!asset?.ownerId) return null;
    return this.players.find(player => player.id === asset.ownerId) || null;
  }

  propertiesOf(playerOrId) {
    const playerId = typeof playerOrId === 'string' ? playerOrId : playerOrId?.id;
    if (!playerId) return [];
    return Object.keys(this.assets)
      .map(Number)
      .filter(index => this.assets[index]?.ownerId === playerId)
      .sort((a, b) => a - b);
  }

  groupIndices(group) {
    return TYCOON_TILES
      .map((tile, index) => ({ tile, index }))
      .filter(entry => entry.tile.type === 'property' && entry.tile.group === group)
      .map(entry => entry.index);
  }

  ownsGroup(playerOrId, group) {
    const playerId = typeof playerOrId === 'string' ? playerOrId : playerOrId?.id;
    const indices = this.groupIndices(group);
    return Boolean(playerId && indices.length && indices.every(index => this.assets[index]?.ownerId === playerId));
  }

  addLog(message) {
    this.log.push(message);
    if (this.log.length > 120) this.log.shift();
  }

  syncPlayerProperties() {
    this.players.forEach(player => {
      player.properties = this.propertiesOf(player.id);
    });
  }

  credit(player, amount, reason = '') {
    const value = Math.max(0, Math.round(Number(amount) || 0));
    player.cash += value;
    if (reason) this.addLog(`${player.name}: +${formatVnd(value)} · ${reason}`);
    return value;
  }

  requestPayment(player, amount, reason = '', recipient = null) {
    const value = Math.max(0, Math.round(Number(amount) || 0));
    if (value === 0) return true;

    if (player.cash >= value) {
      player.cash -= value;
      if (recipient && !recipient.bankrupt) recipient.cash += value;
      this.addLog(`${player.name}: -${formatVnd(value)}${reason ? ` · ${reason}` : ''}`);
      if (recipient && !recipient.bankrupt) this.addLog(`${recipient.name}: +${formatVnd(value)} · Nhận từ ${player.name}`);
      return true;
    }

    this.pendingDebt = {
      playerId: player.id,
      amount: value,
      reason,
      recipientId: recipient?.id || null
    };
    this.phase = 'debt';
    this.addLog(`${player.name} cần thanh toán ${formatVnd(value)} nhưng chỉ còn ${formatVnd(player.cash)}. Hãy bán nhà hoặc thế chấp tài sản.`);
    return false;
  }

  payDebt() {
    if (!this.pendingDebt || this.phase !== 'debt') return false;
    const debt = this.pendingDebt;
    const player = this.players.find(p => p.id === debt.playerId);
    if (!player || player.bankrupt || player.cash < debt.amount) return false;
    const recipient = debt.recipientId ? this.players.find(p => p.id === debt.recipientId) : null;
    player.cash -= debt.amount;
    if (recipient && !recipient.bankrupt) recipient.cash += debt.amount;
    this.addLog(`${player.name} đã thanh toán ${formatVnd(debt.amount)}${debt.reason ? ` · ${debt.reason}` : ''}.`);
    if (recipient && !recipient.bankrupt) this.addLog(`${recipient.name}: +${formatVnd(debt.amount)} · Nhận từ ${player.name}`);
    this.pendingDebt = null;

    if (this.pendingAfterDebt?.type === 'jail-move') {
      const steps = this.pendingAfterDebt.steps;
      this.pendingAfterDebt = null;
      player.inJail = false;
      player.jailTurns = 0;
      this.moveBy(player, steps);
      this.resolveLanding(player);
    } else {
      this.pendingAfterDebt = null;
      this.phase = this.finished ? 'finished' : 'end';
    }
    return true;
  }

  declareBankruptcy() {
    if (!this.pendingDebt || this.phase !== 'debt') return false;
    const debt = this.pendingDebt;
    const player = this.players.find(p => p.id === debt.playerId);
    if (!player) return false;
    const creditor = debt.recipientId ? this.players.find(p => p.id === debt.recipientId && !p.bankrupt) : null;

    const owned = this.propertiesOf(player.id);
    owned.forEach(index => {
      const asset = this.assets[index];
      if (!asset) return;
      asset.houses = 0;
      asset.ownerId = creditor?.id || null;
      if (!creditor) asset.mortgaged = false;
    });

    if (creditor && player.cash > 0) {
      creditor.cash += player.cash;
      this.addLog(`${creditor.name} nhận ${formatVnd(player.cash)} tiền mặt còn lại của ${player.name}.`);
    }

    player.cash = 0;
    player.bankrupt = true;
    player.inJail = false;
    player.properties = [];
    this.pendingDebt = null;
    this.pendingAfterDebt = null;
    this.addLog(`${player.name} phá sản${creditor ? ` và chuyển tài sản cho ${creditor.name}` : '; tài sản trở về ngân hàng'}.`);
    this.syncPlayerProperties();

    const active = this.players.filter(p => !p.bankrupt);
    if (active.length === 1) {
      this.winnerId = active[0].id;
      this.phase = 'finished';
      this.addLog(`${active[0].name} chiến thắng.`);
      return true;
    }

    this.phase = 'end';
    return true;
  }

  mortgageValue(index) {
    const tile = TYCOON_TILES[index];
    return isPurchasable(tile) ? Math.floor(tile.price / 2) : 0;
  }

  unmortgageCost(index) {
    return Math.ceil(this.mortgageValue(index) * 1.1);
  }

  getRent(index, diceTotal = 0) {
    const tile = TYCOON_TILES[index];
    const asset = this.assets[index];
    const owner = this.ownerOf(index);
    if (!tile || !asset || !owner || asset.mortgaged) return 0;

    if (tile.type === 'property') {
      if (asset.houses > 0) return tile.rent[Math.min(5, asset.houses)] || 0;
      const base = tile.rent[0] || 0;
      return this.ownsGroup(owner.id, tile.group) ? base * 2 : base;
    }

    if (tile.type === 'railroad') {
      const count = this.propertiesOf(owner.id).filter(i => TYCOON_TILES[i].type === 'railroad' && !this.assets[i].mortgaged).length;
      return money(25 * (2 ** Math.max(0, count - 1)));
    }

    if (tile.type === 'utility') {
      const count = this.propertiesOf(owner.id).filter(i => TYCOON_TILES[i].type === 'utility' && !this.assets[i].mortgaged).length;
      const multiplier = count >= 2 ? 10 : 4;
      return money(multiplier * Math.max(0, Number(diceTotal) || 0));
    }

    return 0;
  }

  moveBy(player, steps) {
    const amount = Math.max(0, Math.trunc(Number(steps) || 0));
    const oldPosition = player.position;
    const raw = oldPosition + amount;
    if (raw >= TYCOON_TILES.length) this.credit(player, TYCOON_PASS_START_BONUS, 'Đi qua BẮT ĐẦU');
    player.position = raw % TYCOON_TILES.length;
    return player.position;
  }

  moveTo(player, target, collectStart = true) {
    const index = asIndex(target);
    if (index === null) return false;
    if (collectStart && index < player.position) this.credit(player, TYCOON_PASS_START_BONUS, 'Đi qua BẮT ĐẦU');
    player.position = index;
    return true;
  }

  sendToJail(player, reason = 'Vào TÙ') {
    player.position = 10;
    player.inJail = true;
    player.jailTurns = 0;
    this.extraRoll = false;
    this.consecutiveDoubles = 0;
    this.pendingProperty = null;
    this.phase = 'end';
    this.addLog(`${player.name}: ${reason}.`);
  }

  payJailFee() {
    const player = this.currentPlayer;
    if (this.finished || this.phase !== 'roll' || !player.inJail || player.cash < TYCOON_JAIL_FEE) return false;
    player.cash -= TYCOON_JAIL_FEE;
    player.inJail = false;
    player.jailTurns = 0;
    this.addLog(`${player.name} trả ${formatVnd(TYCOON_JAIL_FEE)} để ra tù.`);
    return true;
  }

  useJailCard() {
    const player = this.currentPlayer;
    if (this.finished || this.phase !== 'roll' || !player.inJail || player.jailCards < 1) return false;
    player.jailCards--;
    player.inJail = false;
    player.jailTurns = 0;
    this.addLog(`${player.name} dùng thẻ Ra tù miễn phí.`);
    return true;
  }

  rollDice(random = Math.random) {
    if (this.finished || this.phase !== 'roll') return null;
    const player = this.currentPlayer;
    const d1 = 1 + Math.floor(random() * 6);
    const d2 = 1 + Math.floor(random() * 6);
    const total = d1 + d2;
    const isDouble = d1 === d2;
    this.lastRoll = [d1, d2];
    this.lastEvent = null;
    this.pendingProperty = null;

    if (player.inJail) {
      this.extraRoll = false;
      this.consecutiveDoubles = 0;
      if (isDouble) {
        player.inJail = false;
        player.jailTurns = 0;
        this.addLog(`${player.name} tung đôi ${d1}-${d2} và ra tù.`);
        this.moveBy(player, total);
        this.addLog(`${player.name} đến ${TYCOON_TILES[player.position].name}.`);
        this.resolveLanding(player);
        return { dice: [d1, d2], total, position: player.position, playerId: player.id, releasedFromJail: true };
      }

      player.jailTurns++;
      if (player.jailTurns >= 3) {
        this.addLog(`${player.name} đã ở tù 3 lượt và phải trả ${formatVnd(TYCOON_JAIL_FEE)}.`);
        const paid = this.requestPayment(player, TYCOON_JAIL_FEE, 'Phí ra tù');
        if (!paid) {
          this.pendingAfterDebt = { type: 'jail-move', steps: total };
          return { dice: [d1, d2], total, position: player.position, playerId: player.id, jailDebt: true };
        }
        player.inJail = false;
        player.jailTurns = 0;
        this.moveBy(player, total);
        this.addLog(`${player.name} đến ${TYCOON_TILES[player.position].name}.`);
        this.resolveLanding(player);
        return { dice: [d1, d2], total, position: player.position, playerId: player.id, releasedFromJail: true };
      }

      this.addLog(`${player.name} không tung được đôi và tiếp tục ở tù (lượt ${player.jailTurns}/3).`);
      this.phase = 'end';
      return { dice: [d1, d2], total, position: player.position, playerId: player.id, jailed: true };
    }

    if (isDouble) this.consecutiveDoubles++;
    else this.consecutiveDoubles = 0;

    if (this.consecutiveDoubles >= 3) {
      this.addLog(`${player.name} tung đôi 3 lần liên tiếp.`);
      this.sendToJail(player, 'Đi tù vì tung đôi 3 lần liên tiếp');
      return { dice: [d1, d2], total, position: player.position, playerId: player.id, sentToJail: true };
    }

    this.extraRoll = isDouble;
    this.moveBy(player, total);
    this.addLog(`${player.name} tung ${d1} + ${d2}, đến ${TYCOON_TILES[player.position].name}.`);
    this.resolveLanding(player);
    return { dice: [d1, d2], total, position: player.position, playerId: player.id, double: isDouble };
  }

  resolveLanding(player, depth = 0) {
    if (depth > 4 || this.finished) {
      this.phase = this.finished ? 'finished' : 'end';
      return;
    }

    const index = player.position;
    const tile = TYCOON_TILES[index];
    this.pendingProperty = null;

    if (isPurchasable(tile)) {
      const owner = this.ownerOf(index);
      if (!owner) {
        if (player.cash >= tile.price) {
          this.pendingProperty = index;
          this.phase = 'buy';
          this.addLog(`${tile.name} chưa có chủ · Giá ${formatVnd(tile.price)}.`);
        } else {
          this.phase = 'end';
          this.addLog(`${player.name} không đủ tiền mua ${tile.name}.`);
        }
        return;
      }

      if (owner.id !== player.id && !this.assets[index].mortgaged) {
        const diceTotal = this.lastRoll ? this.lastRoll[0] + this.lastRoll[1] : 0;
        const rent = this.getRent(index, diceTotal);
        const paid = this.requestPayment(player, rent, `Tiền thuê ${tile.name}`, owner);
        if (paid) this.phase = 'end';
        return;
      }

      if (this.assets[index].mortgaged) this.addLog(`${tile.name} đang thế chấp nên không thu tiền thuê.`);
      this.phase = 'end';
      return;
    }

    if (tile.type === 'tax') {
      const paid = this.requestPayment(player, tile.amount, tile.name);
      if (paid) this.phase = 'end';
      return;
    }

    if (tile.type === 'chance' || tile.type === 'community') {
      this.drawCard(tile.type, player, depth);
      return;
    }

    if (tile.type === 'goto-jail') {
      this.sendToJail(player, 'Đi thẳng vào TÙ');
      return;
    }

    this.phase = 'end';
  }

  drawCard(deckName, player = this.currentPlayer, depth = 0, random = Math.random) {
    const deck = deckName === 'chance' ? CHANCE_CARDS : COMMUNITY_CARDS;
    const card = deck[Math.floor(random() * deck.length)];
    this.lastEvent = { deck: deckName, text: card.text };
    this.addLog(`${deckName === 'chance' ? 'CƠ HỘI' : 'KHÍ VẬN'}: ${card.text}`);

    if (card.action === 'money') {
      if (card.amount >= 0) {
        this.credit(player, card.amount, card.text);
        this.phase = 'end';
      } else {
        const paid = this.requestPayment(player, Math.abs(card.amount), card.text);
        if (paid) this.phase = 'end';
      }
      return card;
    }

    if (card.action === 'move') {
      this.moveTo(player, card.target, card.collectStart !== false);
      this.addLog(`${player.name} đến ${TYCOON_TILES[player.position].name}.`);
      this.resolveLanding(player, depth + 1);
      return card;
    }

    if (card.action === 'jail') {
      this.sendToJail(player, 'Lá bài yêu cầu vào TÙ');
      return card;
    }

    if (card.action === 'jail-card') {
      player.jailCards++;
      this.phase = 'end';
      return card;
    }

    if (card.action === 'repairs') {
      const owned = this.propertiesOf(player.id);
      let houses = 0;
      let hotels = 0;
      owned.forEach(index => {
        const count = this.assets[index]?.houses || 0;
        if (count >= 5) hotels++;
        else houses += count;
      });
      const amount = houses * card.house + hotels * card.hotel;
      const paid = this.requestPayment(player, amount, card.text);
      if (paid) this.phase = 'end';
      return card;
    }

    this.phase = 'end';
    return card;
  }

  buyProperty() {
    if (this.finished || this.phase !== 'buy' || this.pendingProperty === null) return false;
    const player = this.currentPlayer;
    const index = this.pendingProperty;
    const tile = TYCOON_TILES[index];
    const asset = this.assets[index];
    if (!isPurchasable(tile) || !asset || asset.ownerId || player.cash < tile.price) return false;

    player.cash -= tile.price;
    asset.ownerId = player.id;
    player.properties = this.propertiesOf(player.id);
    this.addLog(`${player.name} mua ${tile.name} với giá ${formatVnd(tile.price)}.`);
    this.pendingProperty = null;
    this.phase = 'end';
    return true;
  }

  skipPurchase() {
    if (this.finished || this.phase !== 'buy') return false;
    this.addLog(`${this.currentPlayer.name} bỏ qua quyền mua ${TYCOON_TILES[this.pendingProperty]?.name || 'tài sản'}.`);
    this.pendingProperty = null;
    this.phase = 'end';
    return true;
  }

  canBuild(index, player = this.currentPlayer) {
    if (this.phase === 'debt') return false;
    const tile = TYCOON_TILES[index];
    const asset = this.assets[index];
    if (!tile || tile.type !== 'property' || !asset || asset.ownerId !== player.id || asset.mortgaged || asset.houses >= 5) return false;
    if (!this.ownsGroup(player.id, tile.group)) return false;
    const group = this.groupIndices(tile.group);
    if (group.some(i => this.assets[i].mortgaged)) return false;
    const min = Math.min(...group.map(i => this.assets[i].houses));
    return asset.houses === min && player.cash >= tile.houseCost;
  }

  buildProperty(index) {
    if (!this.canBuild(index)) return false;
    const player = this.currentPlayer;
    const tile = TYCOON_TILES[index];
    const asset = this.assets[index];
    player.cash -= tile.houseCost;
    asset.houses++;
    this.addLog(`${player.name} xây ${asset.houses === 5 ? 'khách sạn' : `nhà thứ ${asset.houses}`} tại ${tile.name} · -${formatVnd(tile.houseCost)}.`);
    return true;
  }

  canSellBuilding(index, player = this.currentPlayer) {
    const tile = TYCOON_TILES[index];
    const asset = this.assets[index];
    if (!tile || tile.type !== 'property' || !asset || asset.ownerId !== player.id || asset.houses <= 0) return false;
    const group = this.groupIndices(tile.group);
    const max = Math.max(...group.map(i => this.assets[i].houses));
    return asset.houses === max;
  }

  sellBuilding(index) {
    if (!this.canSellBuilding(index)) return false;
    const player = this.currentPlayer;
    const tile = TYCOON_TILES[index];
    const asset = this.assets[index];
    const refund = Math.floor(tile.houseCost / 2);
    const wasHotel = asset.houses === 5;
    asset.houses--;
    player.cash += refund;
    this.addLog(`${player.name} bán ${wasHotel ? 'khách sạn' : '1 nhà'} tại ${tile.name} · +${formatVnd(refund)}.`);
    return true;
  }

  canMortgage(index, player = this.currentPlayer) {
    const tile = TYCOON_TILES[index];
    const asset = this.assets[index];
    if (!isPurchasable(tile) || !asset || asset.ownerId !== player.id || asset.mortgaged || asset.houses > 0) return false;
    if (tile.type === 'property') {
      const group = this.groupIndices(tile.group);
      if (group.some(i => this.assets[i].houses > 0)) return false;
    }
    return true;
  }

  mortgageProperty(index) {
    if (!this.canMortgage(index)) return false;
    const player = this.currentPlayer;
    const asset = this.assets[index];
    const value = this.mortgageValue(index);
    asset.mortgaged = true;
    player.cash += value;
    this.addLog(`${player.name} thế chấp ${TYCOON_TILES[index].name} · +${formatVnd(value)}.`);
    return true;
  }

  canUnmortgage(index, player = this.currentPlayer) {
    if (this.phase === 'debt') return false;
    const tile = TYCOON_TILES[index];
    const asset = this.assets[index];
    return Boolean(isPurchasable(tile) && asset && asset.ownerId === player.id && asset.mortgaged && player.cash >= this.unmortgageCost(index));
  }

  unmortgageProperty(index) {
    if (!this.canUnmortgage(index)) return false;
    const player = this.currentPlayer;
    const asset = this.assets[index];
    const cost = this.unmortgageCost(index);
    player.cash -= cost;
    asset.mortgaged = false;
    this.addLog(`${player.name} chuộc ${TYCOON_TILES[index].name} · -${formatVnd(cost)}.`);
    return true;
  }

  netWorth(player = this.currentPlayer) {
    if (!player) return 0;
    let total = player.cash;
    this.propertiesOf(player.id).forEach(index => {
      const tile = TYCOON_TILES[index];
      const asset = this.assets[index];
      total += asset.mortgaged ? this.mortgageValue(index) : tile.price;
      if (tile.type === 'property' && asset.houses) total += asset.houses * Math.floor(tile.houseCost / 2);
    });
    return total;
  }

  endTurn() {
    if (this.finished || this.phase !== 'end') return false;
    const player = this.currentPlayer;

    if (this.extraRoll && !player.inJail && !player.bankrupt) {
      this.extraRoll = false;
      this.phase = 'roll';
      this.lastRoll = null;
      this.pendingProperty = null;
      this.addLog(`${player.name} được tung thêm vì ra đôi.`);
      return true;
    }

    const previous = this.turnIndex;
    this.turnIndex = nextActiveIndex(this.players, this.turnIndex);
    if (this.turnIndex <= previous) this.round++;
    this.phase = 'roll';
    this.lastRoll = null;
    this.pendingProperty = null;
    this.extraRoll = false;
    this.consecutiveDoubles = 0;
    return true;
  }

  snapshot() {
    this.syncPlayerProperties();
    return {
      version: TYCOON_STATE_VERSION,
      players: this.players.map(player => ({ ...player, properties: player.properties.slice() })),
      assets: Object.fromEntries(Object.entries(this.assets).map(([index, asset]) => [index, { ...asset }])),
      turnIndex: this.turnIndex,
      phase: this.phase,
      lastRoll: this.lastRoll ? this.lastRoll.slice() : null,
      pendingProperty: this.pendingProperty,
      pendingDebt: this.pendingDebt ? { ...this.pendingDebt } : null,
      pendingAfterDebt: this.pendingAfterDebt ? { ...this.pendingAfterDebt } : null,
      winnerId: this.winnerId,
      round: this.round,
      extraRoll: this.extraRoll,
      consecutiveDoubles: this.consecutiveDoubles,
      lastEvent: this.lastEvent ? { ...this.lastEvent } : null,
      log: this.log.slice()
    };
  }

  static fromSnapshot(snapshot) {
    if (!snapshot || !Array.isArray(snapshot.players) || snapshot.players.length < 2 || snapshot.players.length > 4) return null;
    const game = new TycoonGame(snapshot.players.length);
    const legacyMoneyScale = Number(snapshot.version) >= TYCOON_STATE_VERSION ? 1 : TYCOON_MONEY_SCALE;
    const validIds = new Set();
    const usedAvatarIds = new Set();

    game.players = snapshot.players.map((player, i) => {
      let id = typeof player.id === 'string' && player.id ? player.id.slice(0, 48) : `p${i + 1}`;
      if (validIds.has(id)) id = `p${i + 1}`;
      validIds.add(id);
      const seatIndex = Number.isInteger(Number(player.seatIndex))
        ? Math.max(0, Math.min(3, Math.trunc(Number(player.seatIndex))))
        : i;
      let avatarId = normalizeTycoonAvatarId(player.avatarId, seatIndex);
      if (usedAvatarIds.has(avatarId)) {
        avatarId = TYCOON_AVATAR_IDS.find(candidate => !usedAvatarIds.has(candidate))
          || defaultTycoonAvatarForSeat(seatIndex);
      }
      usedAvatarIds.add(avatarId);
      return {
        id,
        name: typeof player.name === 'string' ? player.name.slice(0, 40) : `Người chơi ${i + 1}`,
        seatIndex,
        avatarId,
        cash: Math.max(0, Math.round(Number(player.cash) || 0) * legacyMoneyScale),
        position: Math.max(0, Math.min(TYCOON_TILES.length - 1, Math.trunc(Number(player.position) || 0))),
        properties: [],
        bankrupt: Boolean(player.bankrupt),
        inJail: Boolean(player.inJail),
        jailTurns: Math.max(0, Math.min(3, Math.trunc(Number(player.jailTurns) || 0))),
        jailCards: Math.max(0, Math.min(4, Math.trunc(Number(player.jailCards) || 0)))
      };
    });

    const incomingAssets = snapshot.assets && typeof snapshot.assets === 'object' ? snapshot.assets : null;
    if (incomingAssets) {
      Object.keys(game.assets).forEach(key => {
        const state = sanitizeAssetState(incomingAssets[key]);
        if (!validIds.has(state.ownerId)) state.ownerId = null;
        if (TYCOON_TILES[Number(key)].type !== 'property') state.houses = 0;
        game.assets[key] = state;
      });
    } else {
      // v1 migration: ownership used to live only in player.properties.
      snapshot.players.forEach((player, playerIndex) => {
        const ownerId = game.players[playerIndex].id;
        if (!Array.isArray(player.properties)) return;
        player.properties.forEach(rawIndex => {
          const index = asIndex(rawIndex);
          if (index === null || !game.assets[index] || game.assets[index].ownerId) return;
          game.assets[index].ownerId = ownerId;
        });
      });
    }

    game.syncPlayerProperties();
    game.turnIndex = Math.max(0, Math.min(game.players.length - 1, Math.trunc(Number(snapshot.turnIndex) || 0)));
    if (game.players[game.turnIndex]?.bankrupt) game.turnIndex = nextActiveIndex(game.players, game.turnIndex);
    game.phase = ['roll', 'buy', 'end', 'debt', 'finished'].includes(snapshot.phase) ? snapshot.phase : 'roll';
    game.lastRoll = Array.isArray(snapshot.lastRoll) && snapshot.lastRoll.length === 2
      ? snapshot.lastRoll.map(value => Math.max(1, Math.min(6, Math.trunc(Number(value) || 1))))
      : null;
    const pendingIndex = asIndex(snapshot.pendingProperty);
    game.pendingProperty = pendingIndex !== null && isPurchasable(TYCOON_TILES[pendingIndex]) ? pendingIndex : null;
    game.pendingDebt = snapshot.pendingDebt && typeof snapshot.pendingDebt === 'object'
      ? {
          playerId: validIds.has(snapshot.pendingDebt.playerId) ? snapshot.pendingDebt.playerId : game.currentPlayer.id,
          amount: Math.max(0, Math.round(Number(snapshot.pendingDebt.amount) || 0) * legacyMoneyScale),
          reason: typeof snapshot.pendingDebt.reason === 'string' ? snapshot.pendingDebt.reason.slice(0, 120) : '',
          recipientId: validIds.has(snapshot.pendingDebt.recipientId) ? snapshot.pendingDebt.recipientId : null
        }
      : null;
    game.pendingAfterDebt = snapshot.pendingAfterDebt?.type === 'jail-move'
      ? { type: 'jail-move', steps: Math.max(2, Math.min(12, Math.trunc(Number(snapshot.pendingAfterDebt.steps) || 2))) }
      : null;
    game.winnerId = validIds.has(snapshot.winnerId) ? snapshot.winnerId : null;
    game.round = Math.max(1, Math.round(Number(snapshot.round) || 1));
    game.extraRoll = Boolean(snapshot.extraRoll);
    game.consecutiveDoubles = Math.max(0, Math.min(2, Math.trunc(Number(snapshot.consecutiveDoubles) || 0)));
    game.lastEvent = snapshot.lastEvent && typeof snapshot.lastEvent.text === 'string'
      ? { deck: snapshot.lastEvent.deck === 'chance' ? 'chance' : 'community', text: snapshot.lastEvent.text.slice(0, 220) }
      : null;
    game.log = Array.isArray(snapshot.log)
      ? snapshot.log.filter(value => typeof value === 'string').slice(-120)
      : ['Ván Cờ tỷ phú Việt Nam được khôi phục.'];

    const active = game.players.filter(player => !player.bankrupt);
    if (active.length === 1) {
      game.winnerId = active[0].id;
      game.phase = 'finished';
    }
    if (game.phase === 'debt' && !game.pendingDebt) game.phase = 'end';
    return game;
  }
}
